import React from 'react';
import clsx from 'clsx';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import CloudUpload from '@material-ui/icons/CloudUpload';


import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';

import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToApp from '@material-ui/icons/ExitToApp';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';


import AccountBox from '@material-ui/icons/AccountBoxRounded';
import { mainListItems, secondaryListItems } from './listItems';
import { createMuiTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { amber, green } from '@material-ui/core/colors';


import { loginAction } from '../../actions/getLogin';
import { getProcesos } from '../../actions/getProcesos';

import { postTercero } from '../../actions/postTercero';
import { postProvidencia } from '../../actions/postProvidencia';
import { postDeleteProceso } from '../../actions/postDeleteProceso';


import { getCta } from '../../actions/getCta';

import FrmLogin from './FrmLogin';
import FrmRegistro from './FrmRegistro';
import { store } from '../../store';
import { setValor, setAuthLogin, setAuthLogout, fetchingFrmLogin, openSnackBar, closeSnackBar, sendPost, initPost, openConfirmSnackBar, resetTerceroCuentas, fetchingFrmConsulta, setNuevaProvidencia } from '../../actions'


import ProfileContainer from './ProfileContainer';
import FrmCuentas from './FrmCuentas';
import Cuentas from './Cuentas';
import FrmTerceroCuentas from './FrmTerceroCuentas';


import RptCtasDetallesMes from './RptCtasDetallesMes';
import FrmCarga from './FrmCarga';
import RptCtasDetallesDia from './RptCtasDetallesDia';
import FrmConsulta from './FrmConsulta';




//import { Values } from "redux-form-website-template";


function MadeWithLove() {
  return (
    <div>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Built with love by the '}
        <Link color="inherit" href="https://material-ui.com/">
          Material-UI
      </Link>
        {' team.'}
      </Typography>
      <Typography variant="body2" color="textPrimary" align="center">
        {'Built with love by the '}
        <Link color="inherit" href="https://material-ui.com/">
          Material-UI
      </Link>
        {' team.'}
      </Typography>
    </div>
  );
}

const drawerWidth = 240;  //ancho del menu.


/*
  <color name="primaryColor">#e37222</color>
  <color name="primaryLightColor">#ffa252</color>
  <color name="primaryDarkColor">#ab4400</color>

  <color name="secondaryColor">#0098db</color>
  <color name="secondaryLightColor">#60c9ff</color>
  <color name="secondaryDarkColor">#006aa9</color>

 <color name="secondaryColor">#92d400</color>
  <color name="secondaryLightColor">#c7ff4f</color>
  <color name="secondaryDarkColor">#5da200</color>

  <color name="primaryTextColor">#000000</color>
  <color name="secondaryTextColor">#000000</color>

*/

const themex = createMuiTheme({
  palette: {
    secondary: {
      light: '#60c9ff',
      main: '#3c91a5',
      dark: '#053293',
      contrastText: '#fff',
    },
    primary: {
      light: '#ffa252',
      main: '#053293',
      dark: '#ab4400',
      contrastText: '#fff',
    },
  },
});

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};



const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiListItemIcon-root': {
      color: '#011F60',
      minWidth: 36,
    },
    '& .MuiListSubheader-gutters': {
      paddingLeft: '37px',
      paddingRight: '0px',
      lineHeight: '32px',
    },

    '& .MuiTableCell-sizeSmall': {
      padding: '6px 6px 6px 6px',
      'font-size': '0.75rem',
      'font-weight': '500',
    },

    '& .MuiTableHead-root': {
      backgroundColor: '#3c91a5',
      color: 'fff',
    },

    '& .MuiTableCell-head': {
      color: '#fff',
      'font-size': '0.80rem',

    },




    '& .MuiSvgIcon-root': {
      color: '#3c91a5',
    },

    '& .MuiButton-label': {
      color: '#fff',
    },


    '& .MuiTypography-h5': {
      color: '#3c91a5',
    },

    display: 'flex',

    '& label': {
      color: '#3c91a5',
    },
    '& label.Mui-focused': {
      color: '#053293',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#3c91a5',
      },
      '&:hover fieldset': {
        borderColor: '#053293',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#053293',
      },
    },
  },

  close: {
    padding: theme.spacing(0.2),

  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },

  toolbarIcon: {

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    //'background-color': 'rgba(0, 0, 0, 0.01)',
    color: '#0098db',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(6.7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(6.7),          //tamaño cuando se cierra.
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 340,
  },
  paperLogin: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paperFrm: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '700px',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  seeMore: {
    marginTop: theme.spacing(3),
  },
  iconSmall: {
    fontSize: 20,
  },
  button: {
    margin: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },

  // para el snackBar...
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: amber[700],
  },
  info: {
    backgroundColor: amber[700],
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  textoContenido: {
    fontSize: '0.75rem',
    fontweight: '500',
  },

  formularioOpciones: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-around',
  },

  customTooltip: {
    backgroundColor: '#f8f8f8',
    border: '1px solid #5f5f5f',
    padding: '0 6px 0 6px',
  },
  customTooltipE: {
    color: '#0098db',
  },
  customTooltipI: {
    color: '#011F60',
  },
  customTooltipH: {
    fontWeight: "bold",
  },
  gridDia: {
    color: 'black',
  },

}));

function logOut() {
  store.dispatch(setAuthLogout());
  //debugger;
}


function Portal(props) {
  const classes = useStyles(themex);
  //debugger;
  const [open, setOpen] = React.useState(true);
  const [panel, setPanel] = React.useState(0);

  /*
  const snack = props.snackBar === undefined ? 'init' : props.apiFetch.snackBar;

  var sb = { open: false, mensaje: '' };

  if (!(snack === 'init')) {
    debugger;
    var sbTmp = { open: snack.open, mensaje: snack.mensaje };
    sb = [...sb, ...sbTmp];
    debugger;
  }
  */


  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  //const setValor = value => ({ type: 'setValor', value: value });  
  //debe estar en las actions

  const dashList1 = (event) => {
    //debugger;
    console.log("Menu lista in: " + event.target.innerText);

    //props.setValor(event.target.innerText);
    //store.dispatch(setValor(event.target.innerText));

    switch (event.target.innerText) {
      case "Resumen": setPanel(0); break;
      case "Mis Cuentas": setPanel(3); break;
      case "Mis Datos": setPanel(2); break;
      case "Reports": setPanel(4); break;
      case "Matriz por horas": setPanel(5); break;
      case "Resumen por meses": setPanel(6); break;
      case "Resumen por días": setPanel(7); break;
      default: setPanel(0); break;
    };

    console.log("Menu lista out: " + panel);

  };

  const dashMain = () => {

    let comp = null;
    console.log('Panel redirect: ' + panel);
    switch (panel) {
      case 0: comp = dashConsultas(); store.dispatch(setNuevaProvidencia()); break;
      case 1: comp = dashLogin(); break;
      case 2: comp = dashRegistro(); break;

      //case 4: comp = props.loggedIn ? dashMainTmp() : dashLogin(); break;
      //case 5: comp = props.loggedIn ? dashRptCtasDetalles() : dashLogin(); break;
      case 6: comp = props.loggedIn ? dashRptCtasDetallesMes() : dashLogin(); break;
      case 7: comp = props.loggedIn ? dashRptCtasDetallesDia() : dashLogin(); break;
      case 10: comp = props.loggedIn ? dashCargar() : dashLogin(); break;

      default: dashLogin(); break;
    };

    return (
      comp
    );
  };

  const handleClickCargar = () => {
    setPanel(10);
  }

  const cargaFormSubmit = values => {
    console.log("Se envió el formulario: " + JSON.stringify(values));


    if (!values.archivo || values.archivo === "") {
      store.dispatch(openConfirmSnackBar('Error: No se ha seleccionado archivo.'));
      return;
    }
    store.dispatch(openConfirmSnackBar("Enviado datos por favor espere..."));

    var post = {

      codProceso: values.codProceso,
      magistrado: values.magistrado,
      demandante: values.demandante,
      demandado: values.demandado,
      instancia: values.instancia,
      accion: values.accion,
      descriptor: values.descriptor,
      restrictor: values.restrictor,
      decision: values.decision,
      fecha: values.fecha,
      expediente: values.expediente,
      folder: values.folder,
      extArchivo: values.extArchivo,
    }

    var formBody = [];

    for (var property in post) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(post[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    props.postProvidencia(formBody);


    return;
  }

  const loginFormSubmit = values => {
    //console.log("Se envió el formulario: " + JSON.stringify(values));
    //props.dispatch(setValor(JSON.stringify(values)));
    //auth: { loggedIn: false },
    //props.dispatch(setAuthLogin("xxxx"));

    store.dispatch(resetTerceroCuentas());

    var urlParams = "";
    urlParams += "/" + encodeURIComponent(values.usuario);
    urlParams += "/" + encodeURIComponent(values.password);

    //console.log(urlParams);
    //debugger;

    store.dispatch(fetchingFrmLogin());
    //debugger;

    const info = props.loginAction(urlParams);
    return info;

    //return props.loginAction(urlParams);
  };

  const confirmacionActualizacionTercero = (cta, post) => {
    store.dispatch(openConfirmSnackBar(cta, post));
  }

  const registroFormSubmit = values => {

    var post = {
      terceroNombre1: values.terceroNombre1,
      terceroNombre2: values.terceroNombre2 === undefined ? '' : values.terceroNombre2,
      terceroApellido1: values.terceroApellido1,
      terceroApellido2: values.terceroApellido2 === undefined ? '' : values.terceroApellido2,
      terceroMail: values.terceroMail,
      terceroTel: values.terceroTel === undefined ? '' : values.terceroTel,
      terceroCel: values.terceroCel === undefined ? '' : values.terceroCel,
      terceroDireccion: values.terceroDireccion,
      terceroPassword: values.password
    }

    if (props.loggedIn) {
      //console.log("Ojo porque es una actualizacion... ");      
      post = { ...post, terceroID: props.auth.terceroID };
    }

    var formBody = [];

    for (var property in post) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(post[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }

    formBody = formBody.join("&");

    if (props.loggedIn) {
      //console.log("Ojo porque es una actualizacion... ");      
      post = { ...post, terceroID: props.auth.terceroID };

      //debugger;
      confirmacionActualizacionTercero('Está seguro(a) de actualizar los datos?,updateTercero,', formBody);

      return;
    }

    store.dispatch(sendPost());
    const info = props.postTercero(formBody);
    return info;
  };

  const RegistroformOk = (valores) => {
    //console.log(JSON.stringify(valores.payload));

  }

  const ctasFormSubmit = values => {

    var urlParams = "";
    urlParams += "/" + encodeURIComponent(values.cuenta);

    const info = props.getCta(urlParams);
    return info;
  };

  const consultaFormSubmit = values => {
    var urlParams = "";
    urlParams += "/" + encodeURIComponent(values.busqueda);

    store.dispatch(fetchingFrmConsulta());
    //debugger;

    console.log(urlParams);

    const info = props.getProcesos(urlParams);
    return;
  };

  const ctasFormOk = (valores) => {
    setPanel(3);
  }

  const loginformOk = (valores) => {


    //debugger;
  }

  const dashLogin = () => {

    const frmLoginState = props.apiFetch.FrmLogin === undefined ? 'init' : props.apiFetch.FrmLogin;

    //debugger;
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paperLogin}>

          <Typography component="h1" variant="h5">INICIO DE SESIÓN</Typography>

          <FrmLogin classes={classes} onSubmit={loginFormSubmit} onSubmitSuccess={loginformOk} />

          <Grid container>


            <Grid item xs={12}>
              {frmLoginState === 'fetching' ? <CircularProgress className={classes.progress} /> : ''}

            </Grid>
          </Grid>

        </div>
        <Box mt={5}>

        </Box>
      </Container>
    );
  };

  const dashRegistro = () => {
    const frmRegistroState = props.apiFetch.postState === undefined ? 'init' : props.apiFetch.postState;

    const cod = props.apiFetch.postData === undefined ? 'init' : props.apiFetch.postData.cod;

    if (cod === "1" && frmRegistroState === 'finished') {
      setPanel(1);
      store.dispatch(initPost());
    }

    return (
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <div className={classes.paperLogin}>

          <Typography component="h1" variant="h5"><EditIcon />{props.loggedIn ? 'ACTUALIZACION' : 'REGISTRO'}&nbsp;&nbsp;DE USUARIO</Typography>

          <FrmRegistro classes={classes} onSubmit={registroFormSubmit} onSubmitSuccess={RegistroformOk} />

          <Grid item xs={12}>
            {frmRegistroState === 'running' ? <CircularProgress className={classes.progress} /> : ''}
          </Grid>

        </div>
        <Box mt={5}>

        </Box>
      </Container>
    );
  };


  const dashConsultas = () => {
    return (
      <div>
        <Container component="main" width="100%">
          <CssBaseline />
          <div className={classes.paperLogin}>
            <Typography component="h1" variant="h5">CONSULTA DE JURISPRUDENCIA</Typography>
            <FrmConsulta classes={classes} onSubmit={consultaFormSubmit} />
          </div>
        </Container>

        {props.loggedIn ?
          <Grid container>
            <Grid item xs onClick={handleClickCargar} style={{ margin: "10px" }}>
              <CloudUpload />
              <Link style={{ margin: "10px" }} href="#" variant="body2">Cargar Documento</Link>
            </Grid>
          </Grid> : ''}

        <Grid container>
          <Grid item xs style={{ margin: "10px" }}>

            <Link onClick={() => window.open(`http://solidcloud.com.co/`, "_blank")} style={{ margin: "10px", fontSize: "10px" }} href="#" variant="body2">Powered by SolidCloud</Link>
          </Grid>
        </Grid>

      </div>
    );
  };


  const dashRptCtasDetallesMes = () => {
    return (
      <Grid container spacing={3}>

        <Grid item xs={12}>

          <RptCtasDetallesMes classes={classes} />

        </Grid>
      </Grid>
    );
  }


  const dashCargar = () => {
    return (
      <FrmCarga classes={classes} onSubmit={cargaFormSubmit} />
    );
  }


  const dashRptCtasDetallesDia = () => {
    return (
      <Grid container spacing={3}>

        <Grid item xs={12}>

          <RptCtasDetallesDia classes={classes} />

        </Grid>
      </Grid>
    );
  }

  const dashMainResumen = () => {

    if (props.loggedIn) {
      if (!(props.terceroCuentas === undefined)) {
        if (!(props.terceroCuentas.cta === undefined)) {
          if ((props.terceroCuentas.cta.length === 0) && (props.terceroCuentas.resp === "ok")) {
            setPanel(3);
          }
        }
      }
    }

    return (
      <Grid container spacing={3}>
        {/* Chart */}
        <Grid item xs={12} md={7} lg={8}>
          <Paper className={fixedHeightPaper}>

          </Paper>
        </Grid>
        {/* Recent Deposits */}
        <Grid item xs={12} md={5} lg={4}>
          <Paper className={fixedHeightPaper}>

          </Paper>
        </Grid>
        {/* Recent Orders */}
        <Grid item xs={12}>

          <FrmTerceroCuentas classes={classes} />

        </Grid>
      </Grid>
    );

  }

  return (
    <ThemeProvider theme={themex}>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="absolute" className={clsx(classes.appBar)}>
          <Toolbar className={classes.toolbar}>
            <IconButton edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(classes.menuButton, open && classes.menuButtonHidden)}>
              <MenuIcon />
            </IconButton>
            <img style={{ margin: "10px" }} height='64px' alt='Logo de la empresa.' src={require('./imgs/logoRama.png')} />
            <Typography onClick={() => { setPanel(0) }} style={{ cursor: "pointer" }} component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
              PORTAL DE CONSULTAS - TRIBUNAL ADMINISTRATIVO DEL HUILA
          </Typography>
            <ProfileContainer />

            {
              props.loggedIn
                ? <IconButton color="inherit" onClick={() => logOut(1)}>
                  <Badge badgeContent={0} color="secondary">
                    <ExitToApp />
                  </Badge>
                </IconButton>
                : <IconButton color="inherit" onClick={() => setPanel(1)}>
                  <Badge badgeContent={0} color="secondary">
                    <AccountBox />
                  </Badge>
                </IconButton>
            }

          </Toolbar>
        </AppBar>

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container style={{ maxWidth: "100%" }} className={classes.container}>
            {dashMain()}
          </Container>

          <Snackbar

            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={props.snackBar === undefined ? false : props.snackBar.open}
            autoHideDuration={props.snackBar === undefined ? false : props.snackBar.autoCloseTime}
            onClose={handleClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{props.snackBar === undefined ? false : props.snackBar.mensaje.split(',')[0]}</span>}
            action={[
              <Button key="undo" color="primary" size="small" onClick={() => { handleConfirm(props.snackBar === undefined ? false : props) }}>ACEPTAR</Button>,
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                className={classes.close}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />

        </main>
      </div>
    </ThemeProvider>
  );
}

function handleClick() {
  //setOpen(true);  
}



const handleConfirm = (props) => {
  //console.log('Confirmando...');

  const cta = props.snackBar.mensaje;
  const postParam = props.snackBar.post;

  const comando = cta.split(',')[1];
  const param1 = cta.split(',')[2];
  const param2 = cta.split(',')[3];

  if (comando === undefined) {
    //console.log('...');
  }
  else {
    if (comando === 'updateTercero') {
      //console.log('vuamos a actualizar el tercero...' + postParam.terceroID);

      store.dispatch(sendPost());
      const info = props.postTercero(postParam);
      return info;

    }
    else if (comando === 'actualizarCta') {
      console.log('Recargando los datos de la cuenta...');

      var post = {
        cuentaCodigo: param1,
      }

      var formBody = [];

      for (var property in post) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(post[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }
      formBody = formBody.join("&");

      const info = props.postCuentaDetalleLimpiar(formBody);
      return info;
    }
    else if (comando === 'quitarProvidencia') {

      var post = {
        codProceso: param1,
      }
      var formBody = [];

      for (var property in post) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(post[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }
      formBody = formBody.join("&");

      const info = props.postDeleteProceso(formBody);
      return;
    }
  }

  store.dispatch(closeSnackBar());
}


const handleClose = (cta) => {
  /*
  if (reason === 'clickaway') {
    return;
  }
  */
  //onClick={() => { handleClose(props.snackBar === undefined ? false : props.snackBar.mensaje) }}
  console.log('Cerrando...');
  store.dispatch(closeSnackBar());

  //setOpen(false);
}


const mapStateToProps = (state, props) => ({
  //se filta de una lista a un solo elemnto como propiedad
  //tercero: getUsuarioState(state)
  loggedIn: state.auth.loggedIn,
  apiFetch: state.apiFetch,
  snackBar: state.snackBar,
  auth: state.auth,
  terceroCuentas: state.terceroCuentas,
  //snackBarMensaje: state.SnackBar,

});


export default connect(mapStateToProps, { loginAction, postTercero, getCta, getProcesos, postProvidencia, postDeleteProceso })(Portal);


/*
<Grid container spacing={3}>

  <Grid item xs={12} md={8} lg={9}>
    <Paper className={fixedHeightPaper}>
      <Chart />
    </Paper>
  </Grid>

  <Grid item xs={12} md={4} lg={3}>
    <Paper className={fixedHeightPaper}>
      <Deposits />
    </Paper>
  </Grid>

  <Grid item xs={12}>
    <Paper className={classes.paper}>
      <Orders />
    </Paper>
  </Grid>
</Grid>

*/